import logo from '../images/logo.svg';
import arrowDown from '../images/icon-arrow-down.svg';
import menu from '../images/icon-hamburger.svg'
import menuDark from '../images/icon-hamburger-dark.svg'
import {useState} from 'react'
function Header(){
  const [closedClass,setClosedClass]=useState('nav--btnClose hide');
  const [openClass,setOpenClass]=useState('nav--btnOpen');
  const [linksClass,setLinksClass]=useState('nav--links hide');
    function openHandler(){
          setClosedClass('nav--btnClose')
          setLinksClass('nav--links')
          setOpenClass('nav--btnOpen hide')
    }
    function closeHandler(){
          setClosedClass('nav--btnClose hide')
          setLinksClass('nav--links hide')
          setOpenClass('nav--btnOpen')
    }
 
    return (
        <header className="header txt-white">
       <nav className="nav fs-nav">
        <div className="container nav--container">
            <a href="#" className="nav--logo"><img src={logo} alt="logo" /></a>
            <div className={linksClass}>

                 <a href="#" className="nav--link">About</a>
                <a href="#" className="nav--link">Services</a>
                <a href="#" className="nav--link">Project</a>
                <a href="#" className="nav--contact fw-semi-bold">Contact</a>
         
            </div>
            <div className="nav--btns">
                <button onClick={openHandler} className={openClass}><img src={menu} alt="" /></button>
                <button onClick={closeHandler} className={closedClass}><img src={menuDark} alt="" /></button>
            </div>
        </div>
       </nav>
       <section className="header--main">
        <h1 className="header--heading fs-heading-primary fw-black txtCtr">We are creatives</h1>
        <div className="header--image"><img src={arrowDown} alt="down arrow" /></div>
       </section>
        </header>
    )
}
export default Header;